import api from './api';

export const getListingOffers = async (listingId) => {
  try {
    const response = await api.get(`/api/offers/listings/${listingId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching listing offers:', error);
    throw error;
  }
};

export const createOffer = async (offerData) => {
  try {
    const response = await api.post('/api/offers', offerData);
    return response.data;
  } catch (error) {
    console.error('Error creating offer:', error);
    throw error;
  }
};

export const acceptOffer = async (offerId) => {
  try {
    const response = await api.put(`/api/offers/${offerId}/accept`);
    return response.data;
  } catch (error) {
    console.error('Error accepting offer:', error);
    throw error;
  }
};

export const rejectOffer = async (offerId) => {
  try {
    const response = await api.put(`/api/offers/${offerId}/reject`);
    return response.data;
  } catch (error) {
    console.error('Error rejecting offer:', error);
    throw error;
  }
};

export const getUserOffers = async () => {
  try {
    const response = await api.get('/api/offers/user');
    return response.data;
  } catch (error) {
    console.error('Error fetching user offers:', error);
    throw error;
  }
}; 